import { Component, OnInit } from '@angular/core';
import { PermissionService } from '../utility/PermissionService';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PagerService } from '../shared/pagination';

@Component({
  selector: 'app-access-permission',
  templateUrl: './access-permission.component.html',
  styleUrls: ['./access-permission.component.css']
})
export class AccessPermissionComponent implements OnInit {

  allRows: any[] = [];       // all menu + submenu rows
  dataSource: any[] = [];     // current page rows
  userTypes = ["Admin", "Counsellor", "Third Party"];
  displayedColumns: string[] = ['menu', 'subMenu', 'permission', 'actions'];

  // Pagination
  pager: any = {};
  pagedItems: any[];

  constructor(
    private permissionService: PermissionService,
    private snackBar: MatSnackBar,
    private pagerService: PagerService
  ) { }

  ngOnInit(): void {
    this.loadMenus();
  }

  loadMenus() {
    this.permissionService.getAllMenus().subscribe((menus: any[]) => {
      const rows: any[] = [];

      menus.forEach(menu => {
        (menu.submenu || []).forEach((sm: any) => {
          let types = sm.userType ? sm.userType.split(',') : [];
          if (!types.includes('Admin')) types.unshift('Admin'); // always include Admin

          rows.push({
            menuId: menu.id,
            menuTitle: menu.title,
            menuIcon: menu.icon,

            subId: sm.id,
            subTitle: sm.title,
            subIcon: sm.icon,
            userTypes: types
          });
        });
      });

      this.allRows = rows;
      this.setPage(1); // load first page
    });
  }

  setPage(page: number) {
    this.pager = this.pagerService.getPager(this.allRows.length, page, 8);
    this.pagedItems = this.allRows.slice(this.pager.startIndex, this.pager.endIndex + 1);
    this.dataSource = this.pagedItems;
  }

  saveRow(row: any) {
    const payload = {
      subMenuId: row.subId,
      userType: row.userTypes.join(',')
    };

    this.permissionService.updateSubMenuAccess(payload).subscribe(() => {
      this.snackBar.open(`Permissions updated for "${row.subTitle}"`, 'Close', {
        duration: 3000,
        horizontalPosition: 'right',
        verticalPosition: 'top',
      });
    });
  }

}